import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ModalConfirmAccountsMappingRemove from './Modals/ConfirmAccountsMappingRemove';
import EditRuleModal from './Modals/EditRuleModal';
import LinkUsersModal from './Modals/LinkUsersModal';
import RemoveRuleModal from './Modals/RemoveRuleModal';
import RemoveRuleV3Modal from './Modals/RemoveRuleV3Modal';
import RemoveUsersMapping from './Modals/RemoveUsersMapping';
import SidebarVisibilityMigrationModal from './Modals/SidebarVisibilityMigration';
import SyncWebhooksAfterRuleChangeModal from './Modals/SyncWebhooksAfterRuleChangeModal';
import ValidateWebhooksModal from './Modals/ValidateWebhooksModal';
import AdminTopLevel from './AdminTopLevel';

const Admin = () => (
  <Switch>
    <Route path="/integration-jira-ui/settings/modal/sidebar_visibility_migration" component={SidebarVisibilityMigrationModal}/>
    <Route path="/integration-jira-ui/settings/modal/rule/validate_webhooks" component={ValidateWebhooksModal}/>
    <Route path="/integration-jira-ui/settings/modal/rule/sync_webhooks" component={SyncWebhooksAfterRuleChangeModal}/>
    <Route path="/integration-jira-ui/settings/modal/rule/edit" component={EditRuleModal}/>
    <Route path="/integration-jira-ui/settings/modal/rule/remove" component={RemoveRuleModal}/>
    <Route path="/integration-jira-ui/settings/modal/rule/remove-rule-v3" component={RemoveRuleV3Modal}/>
    <Route path="/integration-jira-ui/settings/modal/confirm_accounts_mapping_remove" component={ModalConfirmAccountsMappingRemove}/>
    <Route path="/integration-jira-ui/settings/modal/link_users" component={LinkUsersModal}/>
    <Route path="/integration-jira-ui/settings/modal/remove_users_mapping" component={RemoveUsersMapping}/>
    <Route path="/integration-jira-ui/settings" component={AdminTopLevel}/>
  </Switch>
);

export default Admin;
